
<div style="padding: 0px;">
  <h1 style="display: inline-block !important;margin:0px;" class="col-sm-11"><i class="fa fa-search text-danger mr-1"></i> Search </h1>
  <!-- <i class="fa fa-window-close" aria-hidden="true" style="position: absolute;top: 0px;right: 0px;"></i>disabled_by_default -->
  <div class="col-sm-1 m-0 text-center"  style="display: inline-block !important;">
    <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: grey;" id="closeBtn" (click)="onNoClick()">close</mat-icon>
  </div>
</div>

<div class="container-fluid mt-md-3">
  <div class="row" style="border-bottom: solid black 1px;">
    <div class="col-sm-5 col-md-3 m-0 p-0">
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Keys available</mat-label>
        <mat-select (selectionChange)="selectionChange($event)">
          <mat-option *ngFor="let item of  keysAvailable" [value]="item.value"
          #matOption >{{item.text}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-7  col-md-7 m-0 p-0 mb-2">
      <mat-form-field hintLabel="Note: Upper and lower cases should be considered"
      appearance="fill" style="width: 100%;" >
        <mat-label>Enter search value </mat-label>
        <input matInput placeholder="ex: unit name" [disabled]="!itemSelectedFromList"
        [(ngModel)]="searchedInputText">
      </mat-form-field>
    </div>
    <div class="col-sm-12 col-md-1">
      <button class="example-button-row w-100" mat-raised-button
      [ngClass]="!itemSelectedFromList?'disabledBtn':'enabledBtn' "
       [disabled]="!itemSelectedFromList" (click)='fetchData()'>
      <i class="fa fa-search"> </i>
    </button>
    </div>
  </div>

  <hr>

<div class="row">
    <div class="col-sm-12 mb-5" >
      <div class="col-sm-12" *ngIf="data.length>0">
        <mat-form-field class="col-sm-12">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
        </mat-form-field>
      </div>


      <table mat-table [dataSource]="tableData" class="col-sm-12 mat-elevation-z8" *ngIf="data.length>0">

        <ng-container matColumnDef="checkBox">
              <th mat-header-cell *matHeaderCellDef class="px-2" style="width:5%">
                <div style="margin:0px;padding:0px;" *ngIf="allowMultipleSelect">
                      <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </div>
            </th>
          <td mat-cell *matCellDef="let row" class="px-2" style="width:5%">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(row) : null;checkboxLabel(row)"
                          [checked]="selection.isSelected(row)"
                        >
            </mat-checkbox>
          </td>
        </ng-container>


        <!-- <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="px-2" style="width:10%"> ID </th>
          <td mat-cell *matCellDef="let element;index as i"  class="px-2" style="width:10%"> {{element.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="system_name">
          <th  mat-header-cell *matHeaderCellDef> System Name </th>
          <td mat-cell *matCellDef="let element"> {{element.system_name}} </td>
        </ng-container>


        <ng-container matColumnDef="system_mac_address">
          <th  mat-header-cell *matHeaderCellDef> System MAC Address </th>
          <td mat-cell *matCellDef="let element"> {{element.system_mac_address?element.system_mac_address:"No data available"}} </td>
        </ng-container>

        <ng-container matColumnDef="system_ip">
          <th  mat-header-cell *matHeaderCellDef> System IP </th>
          <td mat-cell *matCellDef="let element"> {{element.system_ip?element.system_ip:"No data available"}} </td>
        </ng-container>

        <ng-container matColumnDef="sip_registration_uri">
          <th  mat-header-cell *matHeaderCellDef> SIP Registration URI </th>
          <td mat-cell *matCellDef="let element"> {{element.sip_registration_uri?element.sip_registration_uri:"No data available"}} </td>
        </ng-container>

        <ng-container matColumnDef="search_result" >
          <th  mat-header-cell *matHeaderCellDef> {{fillText()}}</th>
          <td mat-cell *matCellDef="let element"> {{element.search_result}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div *ngIf="data.length==0">
        <h5  [style.color]="initialMessageColor">{{initialMessageAndNoData}}</h5>
      </div>

      <mat-paginator [length]='data.length' [pageSize]='5' [pageSizeOptions]="[3, 5, 10]" showFirstLastButtons>
      </mat-paginator>

      <div class="row">
        <div mat-dialog-actions class="col" style="display: flex;justify-content: center;">
          <button class="btn btn-primary" *ngIf="confirmBtnCheck"
          [disabled]="data.length==0 || this.selectedItems.length==0" (click)="onYesClick()">Confirm
          </button>
          <!-- <i class="fa fa-check-circle" style="color: green;" *ngIf="this.selectedItems.length>0"></i> -->
          <!-- <button class="buttonCustomized" style="background-color:#d9534f;color: white;" (click)="onNoClick()">Cancel</button> -->

          <button class="btn btn-danger"  (click)="onNoClick()">Cancel</button>
        </div>
      </div>
    </div>


  </div>
</div>



